/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep04, resetQuotes, setStep04Renewals, getRenewalVariation, fetchTradeFairsLocations
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step04 from '../../../components/pages/Quote/Step04/Step04'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        tradeFairsLocations: state.step00.tradeFairsLocations,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04: setStep04,
        setStep04Renewals: setStep04Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        fetchTradeFairsLocations,
    }
)(Step04)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step04.tsx